// @flow

import * as React from "react"
import Modal from "react-modal"
import {withTranslation} from "react-i18next"
import {connect} from "react-redux"
import Flatpickr from "react-flatpickr"

import {deletePlanningItem, updatePlanningItem} from "../../actions/planning"
import type {PlanningItem, Dispatch} from "../../types"

type Props = {
  +t: any,
  +planningItem: PlanningItem,
  +dispatch: Dispatch,
  +handleCloseModal: () => void,
  +handleAfterOpen: () => void,
}

type State = {
  +planningItem: PlanningItem,
}

type FlatpickrInstance = any

class PlanningItemEditModal extends React.Component<Props, State> {
  handleSave: () => void
  handleDelete: () => void
  handleInputChange: (SyntheticInputEvent<HTMLTextAreaElement>) => void
  handleDateChange: ($ReadOnlyArray<Date>, string, FlatpickrInstance) => void

  constructor(props: Props) {
    super(props)

    this.state = {
      planningItem: this.props.planningItem,
    }

    this.handleSave = this.handleSave.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.handleDateChange = this.handleDateChange.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
  }

  handleInputChange(e: SyntheticInputEvent<HTMLTextAreaElement>) {
    this.setState({
      planningItem: {
        ...this.state.planningItem,
        description: e.currentTarget.value,
      },
    })
  }

  handleDateChange(dates: $ReadOnlyArray<Date>, dateStr: string) {
    dates.forEach((d) => d)
    this.setState({
      planningItem: {...this.state.planningItem, date: dateStr},
    })
  }

  handleSave() {
    const {planningItem} = this.state
    const {dispatch, handleCloseModal} = this.props
    dispatch(updatePlanningItem(planningItem))
    handleCloseModal()
  }

  handleDelete() {
    const {planningItem} = this.state
    const {dispatch, handleCloseModal} = this.props
    dispatch(deletePlanningItem(planningItem))
    handleCloseModal()
  }

  renderBody() {
    const {t} = this.props
    const {planningItem} = this.state

    return (
      <>
        {planningItem.id && (
          <div className="form-group">
            <textarea
              className="form-control"
              autoFocus={true}
              maxLength={5000}
              onChange={this.handleInputChange}
              value={planningItem.description}
            />
          </div>
        )}
        {!planningItem.id && (
          <h6 className="mb-2">
            {t(`dashboard.planning.keys.${planningItem.key || ""}`)}
          </h6>
        )}
        <div className="form-group">
          <label htmlFor="date">{t("dashboard.planning.update.date")}</label>
          <Flatpickr
            options={{
              altFormat: "d/m/Y",
              dateFormat: "Y-m-d",
              altInput: true,
            }}
            value={planningItem.date}
            onChange={this.handleDateChange}
            name="date"
          />
        </div>
        <button className="btn btn-primary" onClick={this.handleSave}>
          {t(`dashboard.planning.update.save`)}
        </button>
        {planningItem.id && (
          <button className="btn btn-danger" onClick={this.handleDelete}>
            {t(`dashboard.planning.update.delete`)}
          </button>
        )}
      </>
    )
  }

  render() {
    const {t} = this.props
    return (
      <Modal
        className="modal-dialog modal-sm"
        isOpen={true}
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={true}
        onRequestClose={this.props.handleCloseModal}
        onAfterOpen={this.props.handleAfterOpen}
        contentLabel={t("dashboard.planning.update.title")}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              {t("dashboard.planning.update.title")}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label={t("dashboard.planning.update.close")}
              onClick={this.props.handleCloseModal}
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>

          <div className="modal-body pt-0">{this.renderBody()}</div>
        </div>
      </Modal>
    )
  }
}

export default withTranslation()(connect()(PlanningItemEditModal))
